export default __webpack_public_path__ + "static/media/true-friends.4b459c66.png";